// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import headTop from './components/head.vue'
import footerBot from './components/footer.vue'

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'uhSI5bcS6HPOsfharXH6q9UxftBGaSua'  //这个地方是官方提供的ak密钥
})

Vue.use(headTop);
Vue.use(footerBot);
Vue.use(ElementUI)
Vue.component('headTop', headTop) // 初始化组件
Vue.component('footerBot', footerBot) // 初始化组件
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App,
        headTop,
        footerBot
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js